<div fxLayoutAlign.gt-md="space-between center" fxLayout.lt-md="column">
  <h1>Pesquisa de Usuário</h1>
</div>

<form [formGroup]="form">
  <mat-form-field appearance="outline" fxFill>
    <mat-icon matSuffix (click)="filtrar()">search</mat-icon>
    <mat-label>Pesquisar por CPF</mat-label>
    <input
      matInput
      formControlName="cpf"
      type="search"
      mask="000.000.000-00"
      [dropSpecialCharacters]="true"
      (keyup)="filtrar()"
      (keydown.enter)="filtrar()"
      #input />
  </mat-form-field>
</form>

<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="Central de acessos">
    <ng-template matTabContent>
      <mat-card class="info" *ngIf="getDataCentral() === 'sem_resultado'">
        <p>Nenhum resultado encontrado para: {{ lastSearch }}</p>
      </mat-card>

      <pre *ngIf="tabStateCentral === 'pronto'">{{ dataCentral | json }}</pre>
    </ng-template>
  </mat-tab>

  <mat-tab label="RH">
    <ng-template matTabContent>
      <mat-card class="info" *ngIf="getDataRH() === 'sem_resultado'">
        <p>Nenhum resultado encontrado para: {{ lastSearch }}</p>
      </mat-card>

      <pre *ngIf="tabStateRH === 'pronto'">{{ dataRH | json }}</pre>
    </ng-template>
  </mat-tab>

  <mat-tab label="Pós-graduação">
    <ng-template matTabContent>
      <mat-card class="info" *ngIf="getDataPos() === 'sem_resultado'">
        <p>Nenhum resultado encontrado para: {{ lastSearch }}</p>
      </mat-card>

      <pre *ngIf="tabStatePos === 'pronto'">{{ dataPos | json }}</pre>
    </ng-template>
  </mat-tab>
</mat-tab-group>
